import { render, staticRenderFns } from "./AttendanceData.vue?vue&type=template&id=0b36cbc8&scoped=true"
import script from "./AttendanceData.vue?vue&type=script&lang=js"
export * from "./AttendanceData.vue?vue&type=script&lang=js"
import style0 from "./AttendanceData.vue?vue&type=style&index=0&id=0b36cbc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b36cbc8",
  null
  
)

export default component.exports